import { render, staticRenderFns } from "./BettingPromotionsList.vue?vue&type=template&id=05e972ad"
import script from "./BettingPromotionsList.vue?vue&type=script&lang=js"
export * from "./BettingPromotionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports